import type { Breadcrumb } from 'Components/Breadcrumbs/Breadcrumbs'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { useMemo } from 'react'
import { t } from 'ttag'

export default function useSalesManagementBreadcrumbs(pages: Breadcrumb[]) {
  const breadcrumbs = useMemo(() => {
    const homeCrumb: Breadcrumb = {
      title: t`Home`,
      link: SALES_MANAGEMENT_ROOT_URL
    }
    return [homeCrumb, ...pages]
  }, [pages])

  return breadcrumbs
}
